import {
  AnalyticsEvent,
  AnalyticsPlatform,
} from '../Context/AnalyticsProvider';
import LogRocket from 'logrocket';
import { FeedbackProvider } from '../Context/FeedbackProvider';

export interface LogrocketAnalyticsPlatformConfig {
  logrocketAppId: string;
  releaseVersion: string;
}
export class LogrocketAnalyticsPlatform
  implements AnalyticsPlatform, FeedbackProvider
{
  constructor(config: LogrocketAnalyticsPlatformConfig) {
    // Not intialized statically because it requires env vars
    LogRocket.init(config.logrocketAppId, {
      release: config.releaseVersion,
    });
  }

  getId() {
    return 'logrocket';
  }
  isEventSupported(event: AnalyticsEvent) {
    return true;
  }
  identifyUser(userId: string, metadata?: any) {
    LogRocket.identify(userId, metadata);
  }
  resetUser() {}
  async trackEvent(event: AnalyticsEvent, metadata?: any): Promise<void> {
    LogRocket.track(event, metadata);
  }

  isInitialized(): boolean {
    return !!document.querySelector('#_lr_guides_root button:not([type])');
  }

  showFeedbackModal(): void {
    const button = document.querySelector(
      '#_lr_guides_root button:not([type])',
    ) as HTMLButtonElement;

    if (button) {
      button.click();
    }
  }
}
